// src/components/AreaProtectedRoute.js
import React, { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import { db } from "../firebase";
import { ref, onValue } from "firebase/database";

export default function AreaProtectedRoute({ children }) {
  const { slug } = useParams();
  const [allowed, setAllowed] = useState(null);
  const [areaId, setAreaId] = useState(null);

  // 🔹 Find areaId only once
  useEffect(() => {
    const areasRef = ref(db, "areas");
    const unsub = onValue(areasRef, (snap) => {
      const val = snap.val() || {};
      const found = Object.entries(val).find(
        ([, v]) => v.meta && v.meta.slug === slug
      );
      if (found) {
        setAreaId(found[0]);
      } else {
        setAreaId(null);
        setAllowed(false);
      }
    });
    return () => unsub();
  }, [slug]);

  // 🔹 Listen only to that area's session
  useEffect(() => {
    if (!areaId) return;
    const sessionRef = ref(db, `sessions/areas/${areaId}/loggedIn`);
    const unsub = onValue(sessionRef, (snap) => {
      const logged = snap.val();
      setAllowed(logged === true);
    });
    return () => unsub();
  }, [areaId]);

  if (allowed === null)
    return (
      <div style={{ textAlign: "center", marginTop: 60 }}>
        Checking access...
      </div>
    );

  if (!allowed) return <Navigate to="/" replace />;

  return children;
}
